<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>
  <div class="row headerResult">
    <div class="col-12">
      <h6>
        تعداد کل جلسات انتخابی:
        <b>{{ semiReserveListCount() == 0 ? '--' : semiReserveListCount() }}</b>
      </h6>
    </div>
  </div>
  <div class="m-2 mt-3 text-center" v-if="semiReserveListCount() == 0">
    <p>لطفا یکی از گزینه‌های زیر را انتخاب کنید:</p>
    <div class="row g-1">
      <div :class="isMobile ? 'col-6' : 'col-lg-3 col-md-6'">
        <button class="btn btn-sm btn-danger w-100 px-1" @click="goToReserve">
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-clock-history ms-2"
            viewBox="0 0 16 16"
          >
            <path
              d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
            ></path>
            <path
              d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
            ></path>
            <path
              d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
            ></path>
          </svg>
          رواندرمانی و روانپزشکی
        </button>
      </div>
      <div :class="isMobile ? 'col-6' : 'col-lg-3 col-md-6'">
        <button
          class="btn btn-sm testSessionsTheme w-100 px-1"
          @click="goToReserveTest"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-journal-check ms-2"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
            ></path>
            <path
              d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
            ></path>
            <path
              d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
            ></path>
          </svg>
          تست و ارزیابی
        </button>
      </div>
      <div :class="isMobile ? 'col-6' : 'col-lg-3 col-md-6'">
        <button
          class="btn btn-sm btn-success text-white w-100 px-1"
          @click="goToGroupTherapy"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-people mb-1"
            viewBox="0 0 16 16"
          >
            <path
              d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
            ></path>
          </svg>
          گروه درمانی
        </button>
      </div>
      <div :class="isMobile ? 'col-6' : 'col-lg-3 col-md-6'">
        <button
          class="btn btn-sm btn-warning text-secondary w-100 px-1"
          @click="goToWorkshop"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-person-workspace mb-1"
            viewBox="0 0 16 16"
          >
            <path
              d="M4 16s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H4Zm4-5.95a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
            ></path>
            <path
              d="M2 1a2 2 0 0 0-2 2v9.5A1.5 1.5 0 0 0 1.5 14h.653a5.373 5.373 0 0 1 1.066-2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9h-2.219c.554.654.89 1.373 1.066 2h.653a1.5 1.5 0 0 0 1.5-1.5V3a2 2 0 0 0-2-2H2Z"
            ></path>
          </svg>
          کارگاه آموزشی
        </button>
      </div>
    </div>
  </div>
  <div
    :class="
      semiReserveListCount() == 0
        ? 'd-flex justify-content-center my-4'
        : 'scrollable-styled-dark'
    "
    :style="!isMobile ? 'overflow: auto; height: 60vh' : ''"
  >
    <template v-for="session in semiReserveList()" :key="session.sessionID">
      <div v-if="hasSessionToReplace()" class="m-2">
        اطلاعات جلسه انتخاب شده شما به منظور
        <span class="fw-bold text-danger-gradient blinkText">جابجایی جلسه</span>
        به شرح زیر است.
      </div>
      <div class="card border-secondary text-dark m-2">
        <h5
          class="card-header"
          :class="
            hasSessionToReplace()
              ? 'bg-success text-white'
              : 'bg-lightsecondary'
          "
        >
          <div class="d-flex justify-content-between">
            <div :class="isMobile ? 'fs-6' : ''">
              نام درمانگر:
              <b :class="isMobile ? 'fs-6' : ''"
                >{{ session.therapistName }}
              </b>
            </div>
            <div>
              <b :class="isMobile ? 'fs-8' : ''" v-if="hasSessionToReplace()"
                >(جلسه جدید)</b
              >
            </div>
          </div>
        </h5>
        <div class="card-body">
          <div class="row m-auto text-right">
            <div class="col-6">
              <h6 :class="isMobile ? 'fs-8' : ''">
                از ساعت:
                <b>{{ getHourAndMinute(session.fromTime) }}</b>
              </h6>
              <h6 :class="isMobile ? 'fs-8' : ''">
                تا ساعت: <b>{{ getHourAndMinute(session.toTime) }}</b>
              </h6>
            </div>
            <div class="col-6">
              <h6 :class="isMobile ? 'fs-8' : ''">
                شیوه برگزاری:
                <b>{{
                  `${session.sessionTypeID == 2 ? 'غیر حضوری' : 'حضوری'}`
                }}</b>
              </h6>
              <h6 :class="isMobile ? 'fs-8' : ''">
                نوع درمان:
                <b>{{ session.therapyTypeTitle }}</b>
              </h6>
            </div>
            <div class="col-md-6 col-12">
              <h6 :class="isMobile ? 'fs-8' : ''">
                تاریخ:
                <b>{{ getPersianDate(session.date) }}</b>
              </h6>
            </div>
            <div class="col-md-6 col-12" v-if="$store.getters.isOverseas">
              <h6 :class="isMobile ? 'fs-8' : ''">
                تاریخ(میلادی):
                <b
                  style="unicode-bidi: bidi-override !important; direction: ltr"
                  class="gregorianDateClass"
                  >{{ getGregorianDateOfSession(session.date) }}</b
                >
              </h6>
            </div>
            <div class="col-md-12">
              <h6
                v-if="!session.isCancelable || session.tariffTypeID == 2"
                :class="isMobile ? 'fs-8' : ''"
              >
                جلسه قابل لغو:
                <b class="text-danger">
                  <i class="fi mdi-close"></i>
                  خیر
                </b>
              </h6>
            </div>
            <div class="col-12">
              <h6 :class="isMobile ? 'fs-8' : ''">
                تعرفه:
                <b>{{ session.tariffType }}</b> -
                <template v-if="hasSessionToReplace()">
                  <template v-if="isPossibleToSetDiscountForNewSession">
                    <b v-if="oldReplacingSession.discountPercent == 0"
                      >{{ thousandSeprator(session.price, ',', '.') }}
                      {{ session.currencyTypeTitle }}</b
                    >
                    <b v-else>
                      {{
                        thousandSeprator(
                          session.price -
                            (session.price *
                              oldReplacingSession.discountPercent) /
                              100,
                          ',',
                          '.'
                        )
                      }}
                      {{ session.currencyTypeTitle }}
                      <span
                        class="text-success"
                        v-if="oldReplacingSession.discountPercent != 0"
                        >(کد تخفیف)</span
                      >
                    </b>
                  </template>
                  <template v-else>
                    <b
                      >{{ thousandSeprator(session.price, ',', '.') }}
                      {{ session.currencyTypeTitle }}</b
                    >
                    <br />
                    <p class="text-danger">
                      کد تخفیف جلسه قبلی، قابل ثبت برای جلسه جدید نمی‌باشد.
                    </p>
                  </template>
                </template>
                <template v-else>
                  <b v-if="session.discountPercent == 0"
                    >{{ thousandSeprator(session.price, ',', '.') }}
                    {{ session.currencyTypeTitle }}</b
                  >
                  <b v-else>
                    {{
                      thousandSeprator(
                        session.price -
                          (session.price * session.discountPercent) / 100,
                        ',',
                        '.'
                      )
                    }}
                    {{ session.currencyTypeTitle }}
                    <span
                      class="text-success"
                      v-if="session.discountPercent != 0"
                      >(کد تخفیف)</span
                    >
                  </b>
                </template>
              </h6>
            </div>
            <div class="col-12" v-if="session.sessionTypeID == 1">
              <h6 :class="isMobile ? 'fs-8' : ''">
                آدرس: <b>{{ session.centerName }}</b>
              </h6>
            </div>
          </div>
          <div class="row">
            <!-- اگر در حالت جابجایی بود کدتخفیف نمایش داده نشود -->
            <!-- اگر کد تخفیف اعمال شده بود، باکس اعمال کد تخفیف نمایش داده نشود -->
            <div
              class="d-flex col-md-6 col-12 col-sm-10 discountInput"
              v-if="session.discountPercent == 0 && !hasSessionToReplace()"
            >
              <button
                class="btn btn-sm btn-blueSite"
                @click="submitDiscount(session, this)"
                :class="isMobile ? 'fs-8 p-1' : ''"
                :style="
                  isMobile
                    ? 'max-height:35px;min-height: 35.9px'
                    : 'height: 40.7188px'
                "
              >
                <svg
                  width="18px"
                  height="18px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-check-all"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"
                  ></path>
                </svg>
                اعمال کد
              </button>
              <input-with-message
                :ref="`inp-${session.sessionID}`"
                :inputClass="isMobile ? 'fs-8' : ''"
                :errorMessage="session.discountError"
                erroMessageClass="text-danger smaller"
                inputPlaceHolder="کد تخفیف..."
                topTitle=""
                :showMessage="false"
                v-model:inputValue="session.DiscountCode"
                input-size="sm"
              />
            </div>
            <div v-else class="text-success col-md-6">
              <template
                v-if="session.discountPercent != 0 && !hasSessionToReplace()"
              >
                <i class="fi fi-box-checked"></i>
                {{ `کد تخفیف ${session.discountPercent} درصد اعمال شد.` }}
              </template>
            </div>
            <div class="col-md-6 col-sm-4 col-12 text-start deleteButton">
              <button
                class="btn btn-sm btn-outline-danger"
                :class="isMobile ? 'fs-8 p-1' : ''"
                @click="confirmationCancelReserveSession(session)"
              >
                <svg
                  width="18px"
                  height="18px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                  ></path>
                </svg>
                حذف
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-if="hasSessionToReplace() && semiReserveListCount() != 0">
      <div class="card border-secondary text-dark m-2">
        <h5
          class="card-header"
          :class="
            hasSessionToReplace() ? 'bg-danger text-white' : 'bg-lightsecondary'
          "
        >
          <div class="d-flex justify-content-between">
            <div :class="isMobile ? 'fs-6' : ''">
              نام درمانگر:
              <b :class="isMobile ? 'fs-6' : ''"
                >{{ oldReplacingSession.therapist }}
              </b>
            </div>
            <div><b :class="isMobile ? 'fs-8' : ''">(جلسه قبلی)</b></div>
          </div>
        </h5>
        <div class="card-body">
          <div class="row m-auto text-right">
            <div class="col-6">
              <h6 :class="isMobile ? 'fs-8' : ''">
                از ساعت:
                <b>{{ getHourAndMinute(oldReplacingSession.fromTime) }}</b>
              </h6>
              <h6 :class="isMobile ? 'fs-8' : ''">
                تا ساعت:
                <b>{{ getHourAndMinute(oldReplacingSession.toTime) }}</b>
              </h6>
            </div>
            <div class="col-6">
              <h6 :class="isMobile ? 'fs-8' : ''">
                شیوه برگزاری:
                <b>{{
                  `${
                    oldReplacingSession.sessionTypeID == 2
                      ? 'غیر حضوری'
                      : 'حضوری'
                  }`
                }}</b>
              </h6>
              <h6 :class="isMobile ? 'fs-8' : ''">
                نوع درمان:
                <b>{{ semiReserveList()[0].therapyTypeTitle }}</b>
              </h6>
            </div>
            <div class="col-md-6 col-12">
              <h6 :class="isMobile ? 'fs-8' : ''">
                تاریخ:
                <b>{{ getPersianDate(oldReplacingSession.date) }}</b>
              </h6>
            </div>
            <div class="col-md-6 col-12">
              <h6 :class="isMobile ? 'fs-8' : ''">
                تاریخ(میلادی):
                <b
                  style="unicode-bidi: bidi-override !important; direction: ltr"
                  class="gregorianDateClass"
                  >{{ getGregorianDateOfSession(oldReplacingSession.date) }}</b
                >
              </h6>
            </div>
            <div class="col-md-12">
              <h6
                v-if="
                  !oldReplacingSession.isCancelable ||
                  oldReplacingSession.tariffTypeID == 2
                "
                :class="isMobile ? 'fs-8' : ''"
              >
                جلسه قابل لغو:
                <b class="text-danger">
                  <i class="fi mdi-close"></i>
                  خیر
                </b>
              </h6>
            </div>
            <div class="col-12">
              <h6 :class="isMobile ? 'fs-8' : ''">
                تعرفه:
                <b>{{ oldReplacingSession.tariffType }}</b> -
                <b
                  >{{ thousandSeprator(oldReplacingSession.price, ',', '.') }}
                  {{ oldReplacingSession.currencyType }}
                  <span
                    v-if="oldReplacingSession.discountPercent != 0"
                    class="text-success"
                    >(کد تخفیف)</span
                  >
                </b>
              </h6>
            </div>
            <div class="col-12" v-if="oldReplacingSession.sessionTypeID == 1">
              <h6 :class="isMobile ? 'fs-8' : ''">
                آدرس: <b>{{ oldReplacingSession.address }}</b>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <div class="previousStepRight">
      <button
        class="btn btn-sm"
        @click="previousTab()"
        v-if="semiReserveListCount() != 0"
      >
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-arrow-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
          ></path>
        </svg>
        <span> گام قبلی </span>
      </button>
    </div>
    <div class="nextStepLeft">
      <button
        class="btn btn-sm btn-danger"
        @click="openInvoiceConfirmation()"
        v-if="semiReserveListCount() != 0"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-receipt-cutoff"
          viewBox="0 0 16 16"
        >
          <path
            d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zM11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
          />
          <path
            d="M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293 2.354.646zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118l.137-.274z"
          />
        </svg>
        {{ hasSessionToReplace() ? 'تایید جابجایی' : 'ثبت' }}
      </button>
    </div>
  </div>
  <site-modal
    ID="invoiceConfirmation"
    modalSize="medium"
    :modalHasFooter="false"
    @Closed="closedInvoiceConfirmation"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6 v-if="goTosessionsListSuccessfully">
          <i class="fi mdi-check"></i>
          ثبت موفق
        </h6>
        <h6 v-else>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-receipt"
            viewBox="0 0 16 16"
          >
            <path
              d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"
            />
            <path
              d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
            />
          </svg>
          {{ hasSessionToReplace() ? 'تایید جابجایی' : 'ایجاد صورت حساب' }}
        </h6>
      </div>
    </template>
    <template #body>
      <validation-summery
        v-if="invoiceConfirmationModalHasError"
        :errors="invoiceConfirmationModalError"
      ></validation-summery>
      <template v-if="!goTosessionsListSuccessfully">
        <div>
          <p v-if="defferenceOldAndNewPrice < 0">
            مبلغ مابه التفاوت جلسه قبل و جلسه جدید
            <b>
              {{
                thousandSeprator(Math.abs(defferenceOldAndNewPrice), ',', '.')
              }}
              {{
                ' ' + this.$store.getters.replacedSessionData.currencyType
              }}</b
            >
            است و درصورت تایید این عملیات مبلغ ذکر شده میبایست پرداخت شود.
          </p>
          <p class="mb-2" style="text-align: justify">
            {{
              hasSessionToReplace()
                ? 'آیا از ثبت عملیات جابجایی جلسه با توجه به صحت نام درمانگر، تاریخ، ساعت و محل انجام جلسه اطمینان دارید؟'
                : 'آیا از نام درمانگر، تاریخ، ساعت و محل انجام جلسه اطمینان دارید؟'
            }}
          </p>
          <div>
            <template
              v-for="(session, index) in semiReserveList()"
              :key="session.sessionID"
            >
              <div class="card m-1">
                <div class="card-header p-1 bg-secondary text-white">
                  #جلسه {{ index + 1 }}
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-6" :class="isMobile ? 'fs-8' : ''">
                      شیوه برگزاری:
                      <b>{{
                        `${session.sessionTypeID == 2 ? 'غیر حضوری' : 'حضوری'}`
                      }}</b>
                    </div>
                    <div class="col-6" :class="isMobile ? 'fs-8' : ''">
                      از ساعت:
                      <b>{{ session.fromTime }}</b>
                    </div>
                    <div class="col-6" :class="isMobile ? 'fs-8' : ''">
                      تا ساعت:
                      <b>{{ session.toTime }}</b>
                    </div>
                    <div
                      class="col-6"
                      :class="isMobile ? 'fs-8' : ''"
                      v-if="!session.isCancelable || session.tariffTypeID == 2"
                    >
                      جلسه قابل لغو:
                      <b class="text-danger">
                        <i class="fi mdi-close"></i>
                        خیر
                      </b>
                    </div>
                    <div class="col-6" :class="isMobile ? 'fs-8' : ''">
                      درمانگر:
                      <b>
                        <b>{{ session.therapistName }} </b>
                      </b>
                    </div>
                    <div class="col-md-6 col-12">
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        تاریخ:
                        <b>{{ getPersianDate(session.date) }}</b>
                      </h6>
                    </div>
                    <div
                      class="col-md-6 col-12"
                      v-if="$store.getters.isOverseas"
                    >
                      <h6 :class="isMobile ? 'fs-8' : ''">
                        تاریخ(میلادی):
                        <b
                          style="
                            unicode-bidi: bidi-override !important;
                            direction: ltr;
                          "
                          class="gregorianDateClass"
                          >{{ getGregorianDateOfSession(session.date) }}</b
                        >
                      </h6>
                    </div>
                    <div
                      class="col-12 mt-3"
                      :class="isMobile ? 'fs-8' : ''"
                      v-if="session.sessionTypeID == 1"
                    >
                      آدرس:
                      <b>{{ session.centerName }}</b>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <p
              v-if="
                semiReserveList().some((s) => !s.isCancelable) ||
                semiReserveList().some((s) => s.tariffTypeID == 2)
              "
            >
              <i
                class="fi fi-round-info-full text-danger-gradient blinkText"
              ></i>
              توجه داشته باشید جلسات قابلیت
              <b>لغو یا جابجایی</b>
              ندارند.
            </p>
          </div>
          <hr class="m-2" />
        </div>
        <div class="mt-4 d-flex justify-content-between">
          <button
            class="btn btn-sm btn-outline-blueSite"
            @click="confirmMakingInvoice"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-check-lg"
              viewBox="0 0 16 16"
            >
              <path
                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
              ></path>
            </svg>
            بلی
          </button>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="closedInvoiceConfirmation"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-x-lg"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
              ></path>
              <path
                fill-rule="evenodd"
                d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
              ></path>
            </svg>
            خیر
          </button>
        </div>
      </template>
      <template v-else>
        <p class="mb-2" style="text-align: justify">
          جلسه مورد نظر شما با موفقیت جابجا گردید و در لیست جلسات قرار گرفت.
        </p>
        <hr class="m-2" />
        <div class="mt-4 text-center">
          <button class="btn btn-sm btn-blueSite" @click="gotItResult">
            <svg
              class="float-start"
              width="18px"
              height="18px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
              ></path>
              <path
                fill-rule="evenodd"
                d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zm4.354 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
            </svg>
            لیست جلسات
          </button>
        </div>
      </template>
    </template>
  </site-modal>
  <site-modal
    ID="cancelConfirmationSession"
    modalSize="semiMedium"
    :modalHasFooter="false"
    @Closed="closedcancelConfirmationSession"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-receipt"
            viewBox="0 0 16 16"
          >
            <path
              d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"
            />
            <path
              d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
            />
          </svg>
          حذف جلسه
        </h6>
      </div>
    </template>
    <template #body>
      <validation-summery
        v-if="cancelSessionModalHasError"
        :errors="cancelSessionModalError"
      ></validation-summery>
      <div v-if="selectSessionToDelete != null">
        <p class="mb-2" style="text-align: justify">
          آیا مایل به حذف این جلسه هستید؟
        </p>
        <hr class="m-2" />
        <div class="row">
          <div class="col-6">
            <h6 :class="isMobile ? 'fs-6' : ''">
              از ساعت:
              <b>{{ getHourAndMinute(selectSessionToDelete.fromTime) }}</b>
            </h6>
          </div>
          <div class="col-6">
            <h6 :class="isMobile ? 'fs-6' : ''">
              تا ساعت:
              <b>{{ getHourAndMinute(selectSessionToDelete.toTime) }}</b>
            </h6>
          </div>
          <div class="col-6">
            <h6 :class="isMobile ? 'fs-6' : ''">
              شیوه برگزاری:
              <b>{{
                `${
                  selectSessionToDelete.sessionTypeID == 2
                    ? 'غیر حضوری'
                    : 'حضوری'
                }`
              }}</b>
            </h6>
          </div>
          <div class="col-6">
            <h6 :class="isMobile ? 'fs-6' : ''">
              نوع درمان:
              <b>{{ selectSessionToDelete.therapyTypeTitle }}</b>
            </h6>
          </div>
          <div class="col-6">
            <h6 :class="isMobile ? 'fs-6' : ''">
              تعرفه:
              <b>{{ selectSessionToDelete.tariffType }}</b>
            </h6>
          </div>
          <div class="col-6">
            <h6
              v-if="
                !selectSessionToDelete.isCancelable ||
                selectSessionToDelete.tariffTypeID == 2
              "
              :class="isMobile ? 'fs-6' : ''"
            >
              جلسه قابل لغو:
              <b class="text-danger">
                <i class="fi mdi-close"></i>
                خیر
              </b>
            </h6>
          </div>
          <div class="col-12">
            <h6 :class="isMobile ? 'fs-6' : ''">
              قیمت:

              <template v-if="hasSessionToReplace()">
                <b v-if="oldReplacingSession.discountPercent == 0"
                  >{{
                    thousandSeprator(selectSessionToDelete.price, ',', '.')
                  }}
                  {{ selectSessionToDelete.currencyTypeTitle }}</b
                >
                <b v-else>
                  {{
                    thousandSeprator(
                      selectSessionToDelete.price -
                        (selectSessionToDelete.price *
                          oldReplacingSession.discountPercent) /
                          100,
                      ',',
                      '.'
                    )
                  }}
                  {{ selectSessionToDelete.currencyTypeTitle }}
                  <span
                    class="text-success"
                    v-if="oldReplacingSession.discountPercent != 0"
                    >(کد تخفیف)</span
                  >
                </b>
              </template>
              <template v-else>
                <b v-if="selectSessionToDelete.discountPercent == 0"
                  >{{
                    thousandSeprator(selectSessionToDelete.price, ',', '.')
                  }}
                  {{ selectSessionToDelete.currencyTypeTitle }}</b
                >
                <b v-else>
                  {{
                    thousandSeprator(
                      selectSessionToDelete.price -
                        (selectSessionToDelete.price *
                          selectSessionToDelete.discountPercent) /
                          100,
                      ',',
                      '.'
                    )
                  }}
                  {{ selectSessionToDelete.currencyTypeTitle }}
                  <span
                    class="text-success"
                    v-if="selectSessionToDelete.discountPercent != 0"
                    >(کد تخفیف)</span
                  >
                </b>
              </template>
            </h6>
          </div>
          <div
            class="col-12"
            v-if="selectSessionToDelete.sessionTypeID == 1"
            :class="isMobile ? 'fs-6' : ''"
          >
            <h6>
              آدرس: <b>{{ selectSessionToDelete.centerName }}</b>
            </h6>
          </div>
        </div>
      </div>
      <div class="mt-4 d-flex justify-content-between">
        <button
          class="btn btn-sm btn-outline-blueSite"
          @click="confirmCancelSession(selectSessionToDelete.sessionID)"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-lg"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
            ></path>
          </svg>
          بلی
        </button>

        <button
          class="btn btn-sm btn-outline-danger"
          @click="closedcancelConfirmationSession"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            ></path>
          </svg>
          خیر
        </button>
      </div>
    </template>
  </site-modal>
</template>
<script>
import axios from 'axios';
import LoadingSpinner from '../../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import InputWithMessage from '../../../../../components/form/inputWithMessage/InputWithMessage.vue';
import ValidationSummery from '../../../../../components/form/errorBox/ValidationSummery.vue';
import { Modal } from 'bootstrap';
import { isMobile } from 'mobile-device-detect';
export default {
  components: {
    LoadingSpinner,
    InputWithMessage,
    ValidationSummery,
  },
  inject: [
    'previousStep',
    'nextStep',
    'semiReserveList',
    'deleteSemiSession',
    'WalletList',
    'semiReserveListCount',
    'hasSessionToReplace',
    'clearSemiReserveList',
    'cancelReserveSession',
  ],
  data() {
    return {
      oldReplacingSession: new Object({
        address: '',
        currencyType: '',
        currencyTypeID: 1,
        date: '',
        discountCode: null,
        discountPercent: null,
        fromTime: '',
        holdingStatus: '',
        holdingStatusID: 0,
        id: 0,
        isCancelable: true,
        isEmergency: false,
        isMoveable: true,
        price: 0,
        pschologyOrganizationLink: null,
        sessionType: '',
        sessionTypeID: 0,
        therapist: '',
        therapistID: 0,
        therapyType: '',
        therapyTypeID: 1,
        toTime: '',
      }),
      defferenceOldAndNewPrice: 0,
      isPossibleToSetDiscountForNewSession: true,
      cancelSessionModalHasError: false,
      cancelSessionModalError: [],
      invoiceConfirmationModalHasError: false,
      invoiceConfirmationModalError: [],
      goTosessionsListSuccessfully: false,
      isMobile: isMobile,
      selectSessionToDelete: null,
      walletList: [],
      sessionsList: [],
      totalPrice: 0,
      totalBalance: 0,
      currencyTypeTitle: 'ریال',
      discountCode: '',
      invoiceConfirmationModal: new Object(),
      cancelConfirmationSessionModal: new Object(),
    };
  },
  props: {
    entityObject: {
      therapyTypeID: null,
      scopeIDs: [],
    },
  },
  methods: {
    goToReserve() {
      this.clearSemiReserveList();
      this.$router.push({
        name: 'selectTherapist',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    goToReserveTest() {
      this.clearSemiReserveList();
      this.$router.push({
        name: 'selectTestSession',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    goToWorkshop() {
      this.$router.push({
        name: 'workshopTab',
        params: { id: this.$store.getters.userPersonID, type: 2 },
      });
    },
    goToGroupTherapy() {
      this.$router.push({
        name: 'workshopTab',
        params: { id: this.$store.getters.userPersonID, type: 1 },
      });
    },
    gotItResult() {
      this.closedInvoiceConfirmation();
      this.$router.push({
        name: 'sessionsTab',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    getDiffrenceOfOldAndNewSessionPrice() {
      let oldSession = this.$store.getters.replacedSessionData;
      if (this.semiReserveListCount() == 0 || oldSession == null) return 0;

      let newPrice = 0;
      if (this.isPossibleToSetDiscountForNewSession)
        newPrice = this.calcPriceWithDiscount(
          this.semiReserveList()[0].price,
          oldSession.discountPercent
        );
      else newPrice = this.semiReserveList()[0].price;
      this.defferenceOldAndNewPrice = oldSession.price - newPrice;
    },
    calcPriceWithDiscount(price, discount) {
      return discount != 0 ? price - (price * discount) / 100 : price;
    },
    async submitDiscount(session) {
      let that = this;
      that.$refs.spinner.show();
      await axios
        .post('/FN/DiscountCode/ApplyDiscountCodeForSite', {
          SessionID: session.sessionID,
          Code: session.DiscountCode,
        })
        .then((response) => {
          if (response.data.success) {
            session.discountPercent = response.data.returnValue.discountPercent;
            session.discountCodeID = response.data.returnValue.id;
            this.$refs.notification.show({
              type: 'success',
              title: `عملیات ثبت کد تخفیف با موفقیت انجام شد.`,
            });
          } else {
            session.discountError = '';
            response.data.errors.forEach((error, index, array) => {
              session.discountError += error.errorMessage;
              if (array.length != 0 && array.length - 1 != index)
                session.discountError += ' - ';

              this.$refs.notification.show({
                type: 'error',
                title: error.errorMessage,
              });
            });
            that.$refs[`inp-${session.sessionID}`][0].showErrorMessage();
          }
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات ثبت کد تخفیف با خطا مواجه شد.`,
          });
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },
    async confirmMakingInvoice() {
      let that = this;
      //اگر در حالت جابجایی جلسه بود
      if (this.hasSessionToReplace()) {
        if (that.isPossibleToSetDiscountForNewSession) {
          that.semiReserveList()[0].discountCode =
            that.oldReplacingSession.discountCode;
        }

        that.$refs.spinner.show();
        await axios
          .post('/CLC/Session/SessionReplacementForSite', {
            SessionID: that.oldReplacingSession.id,
            ReplacedWithSession: that.semiReserveList()[0],
          })
          .then((response) => {
            if (response.data?.success) {
              that.clearSemiReserveList();
              this.$store.dispatch('removeSessionForReplacement');
              //اگر پاسخ حاوی لیینک پرداخت بود، به صفحه پرداخت هدایت شود
              if (response.data.returnValue) {
                window.location.href = response.data.returnValue;
                return;
              }
              that.$refs.notification.show({
                type: 'success',
                title: `صورت حساب شما با موفقیت تسویه شد.`,
              });
              that.goTosessionsListSuccessfully = true;
            } else {
              that.invoiceConfirmationModalHasError = true;
              that.invoiceConfirmationModalError = response.data.errors.map(
                (i) => i.errorMessage
              );
              response.data.errors.forEach((element) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: element.errorMessage,
                });
              });
            }
          })
          .catch((error) => {
            if (!error.response.data.success) {
              let errorMessages = error.response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              if (errorMessages && errorMessages.length > 0) return;
            }
          })
          .finally(() => {
            that.$refs.spinner.hide();
          });
        return;
      }

      that.$refs.spinner.show();
      await axios
        .post('/CLC/Session/ReserveSiteSessions', that.semiReserveList())
        .then((response) => {
          if (response.data.success) {
            that.$refs.spinner.hide();
            that.closedInvoiceConfirmation();
            that.$router.push({
              name: 'invoiceList',
              id: this.$store.getters.userPersonID,
            });
          } else {
            response.data.errors.forEach((element) => {
              that.$refs.notification.show({
                type: 'error',
                title: element.errorMessage,
              });
            });
          }
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات ثبت جلسه با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },
    closedInvoiceConfirmation() {
      this.invoiceConfirmationModal.hide();
      (this.invoiceConfirmationModalHasError = false),
        (this.invoiceConfirmationModalError = []);
    },
    async openInvoiceConfirmation() {
      //this.invoiceConfirmationModal.show();
      await this.confirmMakingInvoice();
    },

    getWalletByCurrencyType() {
      if (this.walletList.length == 0 || this.semiReserveListCount() == 0) {
        this.totalBalance = 0;
        return 0;
      }
      let wallet = this.walletList.find((f) => {
        return f.currencyTypeID == this.semiReserveList()[0].currencyTypeID;
      });

      if (wallet) {
        this.totalBalance = wallet.balance;
        if (this.totalBalance != 0) this.useWallet = true;
        return wallet.balance;
      } else {
        this.totalBalance = 0;
        return 0;
      }
    },
    confirmationCancelReserveSession(session) {
      this.selectSessionToDelete = session;
      this.cancelConfirmationSessionModal.show();
    },
    closedcancelConfirmationSession() {
      this.cancelSessionModalHasError = false;
      this.cancelSessionModalError = [];
      this.cancelConfirmationSessionModal.hide();
      this.selectSessionToDelete = null;
    },
    async confirmCancelSession(sessionID) {
      this.cancelSessionModalError = await this.cancelReserveSession(sessionID);
      this.cancelSessionModalHasError =
        this.cancelSessionModalError.length == 0 ? false : true;
      if (this.cancelSessionModalHasError) return;
      this.closedcancelConfirmationSession();
    },
    getTotalPrice() {
      let sessionList = this.semiReserveList();
      this.totalPrice = 0;
      if (sessionList.length == 0) return;
      sessionList.forEach((session) => {
        this.totalPrice += session.price;
      });
      this.currencyTypeTitle = sessionList[0].currencyTypeTitle;
    },
    nextTab() {
      this.nextStep(null, 'finalConfirm');
    },
    previousTab() {
      this.previousStep('finalConfirm');
    },
    thousandSeprator(number, seprator, decimalPointer) {
      // eslint-disable-next-line
      return thousandSeprator(number, seprator, decimalPointer);
    },
    getHourAndMinute(data) {
      return `${data.split(':')[0]}:${data.split(':')[1]}`;
    },
    getPersianDate(date) {
      // eslint-disable-next-line
      return new persianDate(new Date(date)).format('L');
    },
    getGregorianDateOfSession(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
  },
  async mounted() {
    this.oldReplacingSession = this.$store.getters.replacedSessionData;
    if (this.oldReplacingSession) {
      if (this.oldReplacingSession.discountPercent == null) {
        this.oldReplacingSession.discountPercent = 0;
      }
    }

    this.walletList = this.WalletList();

    this.cancelConfirmationSessionModal = new Modal(
      document.getElementById('cancelConfirmationSession'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.invoiceConfirmationModal = new Modal(
      document.getElementById('invoiceConfirmation'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );

    this.getWalletByCurrencyType();
    this.getTotalPrice();

    if (this.hasSessionToReplace()) {
      let that = this;
      //اگر جلسه قبلی کدتخفیف داشت، آن کد برای جلسه جدید بررسی شود

      if (that.oldReplacingSession.discountCode) {
        that.$refs.spinner.show();
        await axios
          .post('/FN/DiscountCode/CheckDiscountCodeValidityForSite', {
            SessionID: that.semiReserveList()[0].sessionID,
            Code: that.oldReplacingSession.discountCode,
          })
          .then((response) => {
            if (!response.data.success) {
              that.isPossibleToSetDiscountForNewSession = false;
              that.getDiffrenceOfOldAndNewSessionPrice();
            }
          })
          .catch((error) => {
            if (!error.response.data.success) {
              let errorMessages = error.response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              if (errorMessages && errorMessages.length > 0) return;
            }
          })
          .finally(() => {
            that.$refs.spinner.hide();
          });
      }
    }
  },
};
</script>
<style scoped>
@media screen and (max-width: 767px) {
  .deleteButton {
    text-align: start !important;
    margin-top: 5px;
  }
  .discountInput > div {
    width: 70% !important;
  }
}
.bottom-25 {
  bottom: 25px;
}
.headerResult {
  background-color: #4c5e74;
  color: white;
  border-radius: 10px 10px 0px 0px;
  padding: 10px;
}
.top-25 {
  top: 25%;
}
.right-25 {
  right: 25%;
}
.shine {
  background: #4c5e74;
}
</style>
